export default "__VITE_ASSET__ZvcgXBuc__"